import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteVendor } from 'src/store/actions/vendor-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IVendor } from 'src/types/vendor';

interface Props {
    data: IVendor;
}

const DeleteVendorAction: React.FunctionComponent<Props> = ({ data: { id, name } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    return (
        <>
            <button type="button" onClick={() => setOpened(true)} className="btn btn-secondary">
                <FontAwesomeIcon icon={faTrash} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete {`${name}`}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteVendor(
                                    id,
                                    () => {
                                        handleClose();
                                        toast.success('Vendor was successfully deleted.');
                                    },
                                    (errorMessage: string) => {
                                        handleClose();
                                        toast.error(errorMessage);
                                    },
                                ),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteVendorAction;
